import theme from '../assets/music/menu-theme.mp3';
import {MusicController} from '../libs/MusicController.js';

/**
 * The background music: the start screen's theme, carried on through the
 * whole game (src/libs/MusicController.js has the levels and the rules).
 *
 *   music.play()              the start screen, at the menu level
 *   music.setLevel('game')    START: fades down under the game
 *   music.duck(on, reason)    short dips (bus drop-off, LEVEL COMPLETE, TIRED)
 *   music.fadeOut()           the ending starts
 *   music.setLevel('menu')    the end panel: back up to the menu level
 *   music.setPaused(bool)     the game's pause
 *   music.setGameMuted(bool)  the game's mute
 *   music.toggle()            the start screen's music switch (remembered)
 *   music.handOff()           before a reload, so the next page carries on
 */

function storage(name) {
  try {
    return window[name];
  } catch (e) {
    return null; // blocked storage: every read and write is guarded anyway
  }
}

/**
 * gainRoute
 * iOS ignores a media element's volume, so there the level goes through a
 * Web Audio gain instead. Elsewhere the element's own volume is used.
 * @param {HTMLAudioElement} audio
 * @returns {{set: Function, resume: Function}|null}
 */
function gainRoute(audio) {
  const Context = window.AudioContext || window.webkitAudioContext;
  audio.volume = 0.5;
  const fixed = audio.volume !== 0.5;
  audio.volume = 1;
  if (!fixed || !Context) {
    return null;
  }
  try {
    const context = new Context();
    const gain = context.createGain();
    context.createMediaElementSource(audio).connect(gain).connect(context.destination);
    return {
      set(v) {
        gain.gain.value = v;
      },
      resume() {
        if (context.state === 'suspended') {
          context.resume().catch(() => {});
        }
      }
    };
  } catch (e) {
    return null;
  }
}

const music = new MusicController({
  createAudio: () => new Audio(theme),
  doc: document,
  storage: storage('localStorage'),
  session: storage('sessionStorage'),
  gainRoute
});

export default music;
